import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import isEmpty from "lodash/isEmpty";
export default function (isValidationIgnored) {
  return useMemo(function () {
    return function (arg0) {
      return function (_ref) {
        var data = _ref.data,
          parentPath = _ref.parentPath,
          onValidationChange = _ref.onValidationChange,
          isValidationIgnored = _ref.isValidationIgnored,
          fieldValidationMessagesRef = useRef(null),
          fieldValidationMessages = fieldValidationMessagesRef.current,
          _useState = useState(fieldValidationMessages),
          _useState2 = _slicedToArray(_useState, 2),
          pageMessages = _useState2[0],
          setPageMessages = _useState2[1],
          _useState3 = useState(!1),
          _useState4 = _slicedToArray(_useState3, 2),
          hasDoneInitialValidation = _useState4[0],
          setHasDoneInitialValidation = _useState4[1],
          onFieldValidationChanged = useCallback(function (isValid, path, message) {
            var _context,
              fullPath = parentPath ? _concatInstanceProperty(_context = "".concat(parentPath, ".")).call(_context, path) : path,
              messages = _objectSpread({}, fieldValidationMessagesRef.current);
            isValid ? delete messages[fullPath] : messages[fullPath] = [message], setPageMessages(_objectSpread({}, messages)), fieldValidationMessagesRef.current = _objectSpread({}, messages), hasDoneInitialValidation || setHasDoneInitialValidation(!0);
          }, [fieldValidationMessagesRef, hasDoneInitialValidation]);
        return useEffect(function () {
          if (!isValidationIgnored) {
            var areFieldsValid = isEmpty(fieldValidationMessages);
            onValidationChange && onValidationChange(areFieldsValid, fieldValidationMessages);
          }
        }, [data, onValidationChange, fieldValidationMessages, pageMessages, isValidationIgnored]), isValidationIgnored ? null : onFieldValidationChanged;
      }(_objectSpread(_objectSpread({}, arg0), {}, {
        isValidationIgnored: isValidationIgnored
      }));
    };
  }, [isValidationIgnored]);
}